<template>
  <SuggestionsPicker
    v-model="model"
    :models.sync="locationsModel"
    :action="action"
    :multiple="multiple"
    :placeholder="placeholder"
  />
</template>

<script>
import { CareerSuggestionsResource } from 'src/services/suggestions.js';
import { createPropModel, modelValueConfig } from 'src/utils/vue.js';

import SuggestionsPicker from 'src/components/suggestions/SuggestionsPicker/SuggestionsPicker.vue';

export default {
  name: 'LocationPicker',
  components: { SuggestionsPicker },
  model: modelValueConfig(),
  props: {
    modelValue: [Number, String, Array],
    locations: Array,
    multiple: Boolean,
    action: {
      type: Function,
      default: CareerSuggestionsResource.getLocations,
    },
    placeholder: {
      type: String,
      default: 'Введите город, область или страну',
    },
  },
  computed: {
    model: createPropModel('modelValue'),
    locationsModel: createPropModel('locations'),
  },
};
</script>
